import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "entry" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "node" }, null, -1)
const _hoisted_4 = { class: "text-time" }
const _hoisted_5 = { class: "section-right" }
const _hoisted_6 = { class: "title-body mb-1 break-all" }
const _hoisted_7 = { class: "sub-title-body" }
const _hoisted_8 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_9 = { class: "grid grid-cols-3 gap-3 w-2/3" }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "col-span-2 sub-title-body-bold" }, "Total Biaya Tambahan", -1)
const _hoisted_11 = { class: "sub-title-body-bold" }
const _hoisted_12 = { class: "col-span-2 sub-title-body-bold" }
const _hoisted_13 = { class: "sub-title-body-bold" }
const _hoisted_14 = { class: "sub-title-body" }
const _hoisted_15 = { class: "sub-title-body-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.datas, (data) => {
    return (_openBlock(), _createBlock("div", {
      class: "timeline",
      key: data.Id
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("p", _hoisted_4, _toDisplayString(`${$setup.moment(data?.CreatedAt).format('DD MMM YYYY, HH:mm')} WIB`), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("p", _hoisted_6, _toDisplayString(data?.StatusPengirimanStatus ?? '-'), 1),
          _createVNode("p", _hoisted_7, _toDisplayString(data?.Keterangan ?? '-'), 1),
          (data?.StatusPengirimanKode == 'TDA')
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode("p", _hoisted_11, _toDisplayString(`Rp ${_ctx.BiayaTambahan}`), 1)
                ]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.datax, (datas) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "grid grid-cols-3 gap-3 w-2/3 mt-2",
                    key: datas.Id
                  }, [
                    _createVNode("div", _hoisted_12, [
                      _createVNode("p", _hoisted_13, _toDisplayString(datas.MsBiayaTambahanNama), 1),
                      _createVNode("p", _hoisted_14, _toDisplayString(`(${datas.Keterangan})`), 1)
                    ]),
                    _createVNode("p", _hoisted_15, _toDisplayString(`Rp ${datas.Nominal}`), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]))
  }), 128))
}